module.exports = __webpack_public_path__ + "img/spider-arranged-categories-de.2b6649dc.png";